import React from 'react';
import { always } from 'ramda';
import { FormattedMessage } from 'react-intl';

import { renderWhenTrue } from '@utils/rendering';
import { ArtworkList } from '@components/artworkList';
import { BlockWithArtworks } from '@definitions/common.types';
import { getHasProducts } from '@utils/helpers';

import { Container, Title, ListContainer, imageStyles } from './pastArtworks.styles';

export interface PastArtworksProps {
  blocks: BlockWithArtworks[];
  marginTop?: number;
}

export const PastArtworks = ({ blocks = [], marginTop = 0 }: PastArtworksProps) => {
  const hasProducts = getHasProducts(blocks);
  const renderContent = renderWhenTrue(
    always(
      <Container marginTop={marginTop}>
        <ListContainer>
          {blocks.map(({ value }, index) => (
            <ArtworkList artworks={value} imageStyles={imageStyles} key={index} />
          ))}
        </ListContainer>
      </Container>
    )
  );

  return renderContent(hasProducts);
};
